import Link from '@jetbrains/ring-ui/components/link/link'
import type {PlaceId} from '@jetbrains/teamcity-api'
import classNames from 'classnames'

import {useAppSelector} from '../../../../../hooks/react-redux'
import useTimeSelector from '../../../../../hooks/useTimeSelector'
import {PlaceIdList} from '../../../../../pluginSystem/pluginSystem.types'
import Plugin from '../../../../common/Plugin/Plugin'
import {getCachedPlugins} from '../../../../common/Plugin/Plugin.selectors'
import {isPipelinesEnabledInExclusiveMode} from '../../../../pages/PipelinesPages/utils/featureToggles'

import {useFormattedVersionAndDetails} from './Footer.hooks'
import type {Props} from './Footer.types'

import styles from './Footer.css'

function Footer({licenseModeName, buildNumber}: Props) {
  const formattedVersionAndDetails = useFormattedVersionAndDetails()
  const hasExtensions = useAppSelector(
    state =>
      getCachedPlugins(state, 'FOOTER_LINKS' as PlaceId).length > 0 ||
      getCachedPlugins(state, PlaceIdList.SAKURA_FOOTER_RIGHT).length > 0,
  )
  const currentYear = useTimeSelector(now => now.getFullYear())
  if (licenseModeName == null) {
    return null
  }

  return (
    <>
      <div>
        <Link
          href={
            isPipelinesEnabledInExclusiveMode()
              ? 'https://www.jetbrains.com/teamcity/pipelines/?fromServer'
              : 'https://www.jetbrains.com/teamcity/?fromServer'
          }
          target="_blank"
          rel="noreferrer"
        >{`TeamCity ${licenseModeName}`}</Link>{' '}
        {formattedVersionAndDetails}
      </div>
      {buildNumber && <div>{`Build ${buildNumber}`}</div>}
      <div className={styles.copyright}>{`Copyright © 2006–${currentYear} JetBrains s.r.o.`}</div>
      <div className={classNames({[styles.extensionsLinks]: hasExtensions})}>
        <Plugin placeId="FOOTER_LINKS" withoutLoader />
        <Plugin placeId={PlaceIdList.SAKURA_FOOTER_RIGHT} withoutLoader />
      </div>
    </>
  )
}

export default Footer
